// extracted by mini-css-extract-plugin
export var container = "ExcursionActivityLevel-module--container--57c7f";
export var icon = "ExcursionActivityLevel-module--icon--7b779";
export var icons = "ExcursionActivityLevel-module--icons--1c2f8";
export var label = "ExcursionActivityLevel-module--label--66814";
export var title = "ExcursionActivityLevel-module--title--5b62c";